import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from '@angular/common'
import { ErrorPageService, IErrorRoutingState } from "../../services/error-page.service";
import { OutageStatusService } from '../../../../services/outage-status.service';

@Component({
  selector: 'error-page-state',
  templateUrl: './error-page-state.component.html'
})
export class ErrorPageStateComponent {
  @Input() public backButtonEnabled?: boolean;
  @Input() public graphicSrc?: string;
  @Input() public message?: string;
  @Input() public title?: string;
  @Input() public refreshButtonEnabled?: boolean;
  @Output() refreshButtonClickEvent = new EventEmitter<void>();

  constructor(private router: Router, private location: Location, public outageStatusService: OutageStatusService) {
    const defaultValues = ErrorPageService.NotFound;
    const state = this.router.getCurrentNavigation()?.extras.state as IErrorRoutingState;
    this.backButtonEnabled = state?.backButtonEnabled ?? defaultValues.backButtonEnabled;
    this.graphicSrc = state?.graphicSrc ?? defaultValues.graphicSrc;
    this.message = state?.message ?? defaultValues.message;
    this.refreshButtonEnabled = state?.refreshButtonEnabled ?? defaultValues.refreshButtonEnabled;
    this.title = state?.title ?? defaultValues.title;
  }

  get outage$() { return this.outageStatusService.outage$; }

  public onBackBtnClick() {
    this.location.back();
  }

  public async handleRefreshButtonClicked() {
    if(navigator.onLine) {
      window.location.reload();
    }
  }
}